import React from "react";
import Modal from "../../../components/common/modal/modal";
import Button from "../../../components/common/button/button";
import "./modalContent.scss";
import { PlusIconWithBg, AttheRateIcon, FileIcon } from "../../../assets/Icons";
import { useTranslation } from "../../../contexts/TranslationContext";

type ModalContentProps = {
  isVisible: boolean;
  onClose: () => void;
  onGetStarted: () => void;
};

const ModalContent: React.FC<ModalContentProps> = ({ isVisible, onClose, onGetStarted }) => {
  const t = useTranslation();

  const steps = [
    {
      icon: <PlusIconWithBg />,
      title: t.introModal.describeItem,
      description: t.introModal.describeItemDesc,
    },
    {
      icon: <AttheRateIcon />,
      title: t.introModal.provideContact,
      description: t.introModal.provideContactDesc,
    },
    {
      icon: <FileIcon />,
      title: t.introModal.getQuoteInstantly,
      description: t.introModal.getQuoteInstantlyDesc,
    },
  ];

  return (
    <Modal title={t.introModal.title} isOpen={isVisible} onClose={onClose}>
      <div className="modal-content-wrapper">
        <div className="modal-steps">
          {steps.map((step, index) => (
            <div key={index} className="modal-step">
              <div className="icon">{step.icon}</div>
              <div className="text">
                <div className="title">{step.title}</div>
                <div className="description">{step.description}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="modal-note">{t.introModal.note}</div>
        <Button
          label={t.introModal.getStarted}
          onClick={onGetStarted}
          styleType="primary"
          borderRadius="25px"
        />
      </div>
    </Modal>
  );
};

export default ModalContent;
